"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToSpaceKeyIsDown = void 0;
var map_to_target_key_is_down_1 = require("../map-to-target-key-is-down");
var mapToSpaceKeyIsDown = function () { return function (keyEvents$) { return keyEvents$.pipe((0, map_to_target_key_is_down_1.mapToTargetKeyIsDown)(' ')); }; };
exports.mapToSpaceKeyIsDown = mapToSpaceKeyIsDown;
